module.exports = __webpack_public_path__ + "img/pakiet-szkola.fe1ab9de.jpg";